
import { mapGetters } from 'vuex'
import { debounce } from '@/utils'
import { thirdPartyServiceUrl } from '@/settings'
import { addBlankPath } from '@/utils/validate'
const TimeCountdown = () => import('@/components/TimeCountdown')
import dayjs from 'dayjs'
export default {
	components: {
		TimeCountdown
	},
	data() {
		return {
			dialogVisible: false,
			checked: false,
			tipInfo: {},
			// time: null
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			token: 'user/token',
			// noBargainSuccessTipTime: 'user/noBargainSuccessTipTime',
			bargainSuccessId: 'user/bargainSuccessId'
		})
	},
	watch: {},
	methods: {
		//切换选择
		onChangeCheck() {
			this.checked = !this.checked
			if (this.checked) {
				this.$store.commit('user/SET_TIP_TIME', dayjs(new Date()).format('YYYY-MM-DD 23:59:59'))
			} else {
				this.$store.commit('user/SET_TIP_TIME', '')
			}
		},
		//关闭弹窗
		handleClose() {
			this.$store.commit('user/SET_BARGAIN_TIP_ID', this.tipInfo.bargainId)
			this.dialogVisible = false
		},
		//获取弹窗信息
		// async getTipsInfo() {
		// 	if (!this.token) return
		// 	const res = await this.$api.bargainSuccessTip()
		// 	if (!res.success) {
		// 		this.$message.error(res.info)
		// 		return
		// 	}
		// 	if (!res.data) return
		// 	this.tipInfo = res.data || {}
		// 	const bargainSuccessId = Number(this.bargainSuccessId) || null
		// 	if (res.data.bargainId === bargainSuccessId) return
		// 	if (res.data.bargainOrderType === 2) {
		// 		this.time = dayjs(res.data.payEndTime).diff(dayjs(new Date())) / 1000
		// 	}
		// 	const noBargainSuccessTipTime = this.noBargainSuccessTipTime
		// 	if (noBargainSuccessTipTime) {
		// 		if (dayjs(new Date()).isAfter(dayjs(noBargainSuccessTipTime))) {
		// 			this.dialogVisible = true
		// 		}
		// 	} else {
		// 		this.dialogVisible = true
		// 	}
		// },
		//倒计时结束
		onCountDowmEnd() {
			this.$message.error('数据错误，请刷新页面')
		},

		setSaveUserConsultGoods(id) {
			let p = {
				action: {
					goodsNo: this.tipInfo.goodsNo,
					goodsCatalogueId: this.tipInfo.goodsCatalogueId,
					imUserId: id
				}
			}
			this.$api.saveUserConsultGoods(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
				}
			})
		},
		// 立即支付
		onPayNow: debounce(function () {
			if (this.token && !this.userinfo.isRealName) {
				this.$confirm('需先完成实名才能购买', '提示', {
					confirmButtonText: '前去实名',
					cancelButtonText: '取消',
					type: 'warning',
					confirmButtonClass: 'confirmButtonClass'
				})
					.then(() => {
						window.localStorage.setItem('realPath', this.$route.path)
						addBlankPath('/account/realName')
					})
					.catch(() => {})
				return
			}
			// 线上订单
			if (this.tipInfo.bargainOrderType === 2) {
				if (this.tipInfo.orderNo) {
					this.$router.push(`/account/buyerDetails?orderNo=${this.tipInfo.orderNo}`) //&templateId=12
				} else {
					// 没有生成订单则跳转到砍价的订单确认页
					this.$router.push(`/confirmOrder/onlinePay?goodsNo=${this.tipInfo.goodsNo}`)
					const order = {
						...this.tipInfo,
						bargainPrice: this.tipInfo.transactionPrice
					}
					sessionStorage.setItem('orderDtl', JSON.stringify(order))
				}
			}
			//线下订单
			else if (this.tipInfo.bargainOrderType === 1) {
				if (thirdPartyServiceUrl && this.token) {
					let info = {
						action: {
							gameId: this.tipInfo.gameId,
							goodsCatalogueId: this.tipInfo.goodsCatalogueId,
							goodsNo: this.tipInfo.goodsNo
						}
					}
					this.$api.getCustomerService(info).then(res => {
						if (!res.data) {
							this.$message({
								message: '暂无客服值班',
								type: 'error'
							})
							return
						}
						this.setSaveUserConsultGoods(res.data.id)
						this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
						let data = {
							action: {
								goodsNoList: [this.tipInfo.goodsNo]
							}
						}
						this.$api.esRetrieveGoods(data).then(esRes => {
							if (esRes.success) {
								const goodsInformation = {
									goodsId: this.tipInfo.goodsNo,
									price: this.tipInfo.goodsPrice,
									poster: this.tipInfo.goodsImg,
									gameId: this.tipInfo.gameId,
									title: this.tipInfo.title,
									link: window.location.href,
									desc: this.tipInfo.description,
									goodsCatalogueId: this.tipInfo.goodsCatalogueId,
									labelList: esRes.data.length > 0 ? esRes.data[0].labelList : [],
									compensation: this.tipInfo.compensation
								}
								this.$store.dispatch('ry/sendGoodsMsg', {
									targetId: res.data.id,
									content: goodsInformation
								})

								this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
								this.$store.commit('ry/SET_ORDER_FLOW', [])
							} else {
								this.$message.error(res.info)
							}
						})
					})
					this.dialogVisible = false
					return
				}
			}
		})
	},
	created() {},
	// mounted() {
	// 	this.getTipsInfo()
	// }
}
